import React, { FC } from 'react';
import { IWidgetTopRoadSegmentsAccidentsPerKm } from 'models/WidgetData';

interface IProps {
  data: IWidgetTopRoadSegmentsAccidentsPerKm;
  segmentText: string;
}

const TopRoadSegmentsAccidentsPerKm: FC<IProps> = () => {
  return <div> {} </div>;
};
export default TopRoadSegmentsAccidentsPerKm;
